// extracted by mini-css-extract-plugin
module.exports = {"card":"TaxandDialog_card__1XfMJ","actions":"TaxandDialog_actions__3tX2A","cardGraphOffset":"TaxandDialog_cardGraphOffset__BWlqu"};